import { ArticuloContact } from './ArticuloContact';
import {ArticuloService} from "../services/bd/articulo/articulo.service";
import {HojasCallCenterComponent} from "../hojas-call-center.component";

//clase para gestionar el registro de articulo que nos llega del buscador
export class BusArtCallcenter
{
  id: number = 0;
  eurocode: string | null = null;
  ref_ralarsa: string | null = null;
  oem: string | null = null;
  desc: string | null = null;
  campa: boolean = false;


  public static verificarBusArtCallcenter(artBuscador: BusArtCallcenter)
  {
    if (artBuscador.id <= 0)
    {
      //Datos no validos, devolvemos null
      return null;
    }

    // Trim de propiedades utilizando asignación condicional
    artBuscador.ref_ralarsa ? artBuscador.ref_ralarsa = artBuscador.ref_ralarsa.trim() : null;
    artBuscador.eurocode ? artBuscador.eurocode = artBuscador.eurocode.trim() : null;
    artBuscador.oem ? artBuscador.oem = artBuscador.oem.trim() : artBuscador.oem;
    artBuscador.desc ? artBuscador.desc = artBuscador.desc?.trim() : artBuscador.desc;

    //verificamos el resto del contenido
    //SI los campos de articulo (numero), OEM y Eurocode
    //son NULL/cadena vacia, devolvemos NULL para indicar que no es valido.
    if (!artBuscador.ref_ralarsa &&
      !artBuscador.eurocode &&
      !artBuscador.oem) {
      return null;
    }

    return artBuscador;
  }

  //convierte el articulo del buscador de articulo en un articulo valido para la Hoja
  public static async busArt2Articulo(busArt: BusArtCallcenter, taller: number, token: string, articuloServ: ArticuloService, hoja: HojasCallCenterComponent): Promise<ArticuloContact> {
    let resArt: ArticuloContact =
      {
        articulo: "",
        desc: "",
        central: "",
        eurocode: "",
        observaciones: "",
        oem: "",
        reg: "",
        stkcen: 0,
        stktall: 0,
        stkReg: 0,
        taller: "",
        campa: false,
        sub: ""
      };

    busArt.ref_ralarsa ? resArt.articulo = busArt.ref_ralarsa.trim() : "";
    busArt.eurocode ? resArt.eurocode = busArt.eurocode.trim() : "";
    busArt.oem ? resArt.oem = busArt.oem.trim() : "";
    busArt.campa ? resArt.campa = busArt.campa : false;

    if (busArt.desc) {
      //CONTROLAMOS los datos de descripcion ya que tiene un MAXIMO DE 40 caracteres
      busArt.desc = busArt.desc.trim();
      busArt.desc.length > 40 ? busArt.desc = busArt.desc.substring(0, 39) : busArt.desc = busArt.desc.trim();
      resArt.desc = busArt.desc;
    }
    if (busArt.ref_ralarsa && busArt.ref_ralarsa !== "" && taller > 0) {
      const res = await articuloServ.getStockArt(token, busArt.ref_ralarsa, taller);
      if (res) {
        res.forEach((item: { uni_act: number; almacen: number; ped_ven: number; stock_playa: number; }) => {
          if (item.uni_act > 0) {
            if (item.almacen == 900) {
              resArt.stkcen = item.uni_act - item.ped_ven - item.stock_playa;
            } else if (item.almacen == taller) {
              resArt.stktall = item.uni_act;
            } else {
              resArt.stkReg = item.uni_act - item.ped_ven;
            }
          }
        });
      }
    }

    if(busArt.eurocode && busArt.eurocode !== ""){
      const res = await articuloServ.getInfoCrital(token, busArt.eurocode);
      if (res.length > 0){
        resArt.sub = "SUSTITUCION " + res[0].luna + " " + res[0].posicion;
        if (res[0].derecho !== '0'){
          resArt.sub = resArt.sub + " DERECHO";
        }else if (res[0].izquierdo !== '0'){
          resArt.sub = resArt.sub + " IZQUIERDO";
        }
        hoja.auxSusLloc = resArt.sub;
      }
    }

    return resArt;
  }
}
